<template>
  <q-page style="height: 100vh">
    <q-img
      src="/statics/loginBackground.jpg"
      style="height: 100vh; position: absolute; width: 100vw"
    >
    </q-img>
    <div class="row" align="center" justify="center">
      <div class="col">
        <q-card class="loginCard fixed-center">
          <q-card-section class="">
            <div class="row">
              <div class="col-12">
                <div style="max-width: 280px; max-height: 90%">
                  <q-img
                    contain
                    src="/statics/TDRI_Logo_Light.png"
                    spinner-color="white"
                    :ratio="2 / 1"
                  />
                </div>
              </div>
            </div>
          </q-card-section>
          <q-card-section>
            <div class="row">
              <div class="col-12">
                <q-btn
                  block
                  color="primary"
                  dark
                  class="full-width"
                  @click="login()"
                  >Login / Signup</q-btn
                >
              </div>
            </div>
            <!-- <q-form>
              <q-input
                label="Username"
                name="login"
                type="text"
                v-model="username"
                required
              >
                <template #prepend>
                  <q-icon name="mdi-account" />
                </template>
              </q-input>
              <q-input
                id="password"
                :rules="[v => !!v || 'Password is required']"
                label="Password"
                name="password"
                v-model="password"
                @keyup.enter="login"
                required
                :type="hidePassword ? 'password' : 'text'"
              >
                <template #prepend>
                  <q-icon name="mdi-lock" />
                </template>
                <template #append>
                  <q-icon
                    :name="hidePassword ? 'mdi-eye-off' : 'mdi-eye'"
                    class="cursor-pointer"
                    @click="hidePassword = !hidePassword"
                  />
                </template>
              </q-input>
            </q-form>
            <div class="row">
              <div align="left" class="col-12">
                <q-btn
                  flat
                  label="Forgot Password"
                  class="on-left q-pa-none"
                  size="md"
                  @click="forgotPasswordDialog = true"
                >
                </q-btn>
              </div>
              <div class="col-12">
                <q-btn
                  block
                  color="green"
                  dark
                  class="full-width"
                  :loading="loginLoading"
                  @click="login()"
                  >Login</q-btn
                >
              </div>
            </div> -->
          </q-card-section>
        </q-card>
      </div>
    </div>
    <!-- <q-dialog v-model="forgotPasswordDialog" max-width="600px">
      <q-card>
        <q-card-section class="bg-primary text-white q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">
              Password reset
            </div>

            <q-space />
            <q-btn
              color="white"
              round
              flat
              icon="mdi-close"
              @click="forgotPasswordDialog = false"
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <div class="row">
            <q-form ref="forgotPasswordForm">
              <div class="col-12">
                <p>Please enter the email that is associated to the account</p>
              </div>
              <div class="col-12">
                <q-input
                  :rules="[v => !!v || 'Email is required']"
                  label="Username"
                  name="login"
                  prepend-icon="mdi-account"
                  type="text"
                  v-model="username"
                  @keyup.enter="forgotPassword()"
                  required
                ></q-input>
              </div>
              <div class="col-12">
                <q-btn
                  @click="forgotPassword()"
                  class="float-right"
                  color="primary"
                  label="Reset Password"
                >
                </q-btn>
              </div>
            </q-form>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="resetPasswordDialog" max-width="600px" persistent>
      <q-card>
        <q-card-section class="bg-primary text-white q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">
              Enter validation code below
            </div>

            <q-space />
            <q-btn
              color="white"
              round
              flat
              icon="mdi-close"
              @click="resetPasswordDialog = false"
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <div class="row">
            <q-form ref="resetPasswordForm">
              <div class="col-12">
                <p>
                  Please check your email for the verification code, then fill
                  out the form below.
                </p>
              </div>
              <div class="col-12">
                <q-input
                  :rules="[v => !!v || 'The Verification Code is required']"
                  label="Verification Code"
                  name="login"
                  prepend-icon="mdi-code"
                  type="text"
                  v-model="resetCode"
                  required
                ></q-input>
              </div>
              <div class="col-12">
                <q-input
                  id="password"
                  :rules="[v => !!v || 'Password is required']"
                  label="New Password"
                  name="password"
                  prepend-icon="mdi-lock"
                  type="password"
                  v-model="password"
                  @keyup.enter="tryResetCode"
                  required
                  :append-icon="hidePassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="() => (hidePassword = !hidePassword)"
                  :type="hidePassword ? 'password' : 'text'"
                ></q-input>
              </div>
              <div class="col-12">
                <q-btn
                  color="primary"
                  class="float-right"
                  label="Submit"
                  @click="tryResetCode()"
                ></q-btn>
              </div>
            </q-form>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog persistent v-model="newPasswordDialog" max-width="600px">
      <q-card>
        <q-card-section class="bg-primary text-white q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">
              New Password
            </div>

            <q-space />
            <q-btn
              color="white"
              round
              flat
              icon="mdi-close"
              @click="newPasswordDialog = false"
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <div class="row">
            <q-form ref="forcedPasswordResetForm">
              <div class="col-12">
                <p>
                  Because this account was made by an Admin, your tempory
                  password needs to be reset. To reset please type your Desired
                  Password below and click confirm.
                </p>
              </div>
              <div class="col-12">
                <q-input
                  id="password"
                  :rules="[v => !!v || 'Password is required']"
                  label="Password"
                  name="password"
                  prepend-icon="mdi-lock"
                  type="password"
                  v-model="newPassword"
                  @keyup.enter="changeMandatoryPassword"
                  required
                  :append-icon="hidePassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="() => (hidePassword = !hidePassword)"
                  :type="hidePassword ? 'password' : 'text'"
                ></q-input>
              </div>
              <div class="col-12">
                <q-btn
                  @click="changeMandatoryPassword()"
                  :loading="changeTempPasswordLoading"
                  class="float-right"
                  color="primary"
                  label="Confirm"
                >
                </q-btn>
              </div>
            </q-form>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog> -->
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";
import { auth } from "@/firebase.js";

export default {
  computed: {
    ...mapGetters(["siteData", "currentUser", "currentUserData"]),
  },
  data: () => ({
    // newPasswordDialog: false,
    // newPassword: "",
    // changeTempPasswordLoading: false,
    // hidePassword: true,
    // email: "",
    // password: "",
    // loginLoading: false,
    // loginGoogleLoading: false,
    // username: "",
    // emailRules: [
    //   (v) => !!v || "E-mail is required",
    //   (v) => /.+@.+/.test(v) || "E-mail must be valid",
    // ],
    // Reset Passowrd
    // resetCode: "",
    // resetPasswordDialog: false,
    // forgotPasswordDialog: false,
  }),
  watch: {},
  mounted() {},
  methods: {
    // login() {
    //   this.loginLoading = true;
    //   let _this = this;
    //   this.$cognitoAuth.authenticate(
    //     this.username,
    //     this.password,
    //     (err, result) => {
    //       if (err != null) {
    //         if (err.code == "NewPasswordRequired") {
    //           this.newMandatoryPassword();
    //         } else {
    //           this.$swal({
    //             title: "Error",
    //             text: err.message,
    //             type: "error",
    //             confirmButtonText: "Ok",
    //           });
    //         }
    //       } else {
    //         this.$store.dispatch("login", result);
    //       }
    //       this.loginLoading = false;
    //     }
    //   );
    // },

    // // Forgot Password Section
    // async forgotPassword() {
    //   let result = await this.$refs.forgotPasswordForm.validate();
    //   if (result) {
    //     this.$store.dispatch("requestPasswordResetCode", {
    //       username: this.username,
    //     });
    //     this.$q.notify({
    //       position: "top-right",
    //       type: "positive",
    //       message: "Check your inbox",
    //       caption:
    //         "If we find an account with your username you will receive a password reset code.",
    //       timeout: 10000,
    //     });

    //     this.forgotPasswordDialog = false;
    //     this.resetPasswordDialog = true;
    //   }
    // },
    // tryResetCode() {
    //   this.$store
    //     .dispatch("resetPasswordWithCode", {
    //       code: this.resetCode,
    //       username: this.username,
    //       password: this.password,
    //     })
    //     .then((res) => {
    //       if (res.Result == "Success") {
    //         this.$q.notify({
    //           position: "top-right",
    //           type: "positive",
    //           message: "Your password has been Reset",
    //           timeout: 2500,
    //         });

    //         this.resetPasswordDialog = false;
    //       } else {
    //         this.$q.notify({
    //           position: "center",
    //           type: "negative",
    //           message: "The code that was entered was Invalid",
    //           timeout: 1000,
    //         });
    //       }
    //     });
    // },
    // // End Forgot Password Section

    // newMandatoryPassword() {
    //   this.newPasswordDialog = true;
    // },
    // changeMandatoryPassword() {
    //   this.$refs.forcedPasswordResetForm.validate().then((result) => {
    //     if (result) {
    //       this.changeTempPasswordLoading = true;
    //       this.$cognitoAuth.handleNewPassword(
    //         this.username,
    //         this.newPassword,
    //         (err, result) => {
    //           if (err != null) {
    //             this.$q.notify({
    //               position: "center",
    //               type: "negative",
    //               message: err.message,
    //               timeout: 10000,
    //             });
    //           } else {
    //             this.$store.dispatch("initAuth");
    //           }
    //           this.changeTempPasswordLoading = false;
    //         }
    //       );
    //     }
    //   });
    // },
    login() {
      this.$auth.loginWithPopup();
    },
  },
};
</script>

<style>
.loginCard {
  max-width: 600px;
  width: 90vw;
}
</style>
